import { fetchAuditLogs } from "./auditLogService";
import { searchBackups, restoreBackupRecord } from "./backupService";

export async function fetchUndoableOperations({ days = 14, max = 100 } = {}) {
  const logs = await fetchAuditLogs({ days, max });
  const undoable = logs.filter((l) =>
    ["delete_by_condition", "update_by_condition", "find_replace", "bulk_delete", "bulk_update", "update_document"].includes(
      l.action
    )
  );

  const backups = await searchBackups({ max: 200 });
  return { operations: undoable, backups };
}

export async function restoreOperationBackups(backupRecords) {
  let restored = 0;
  let failed = 0;
  for (const rec of backupRecords) {
    try {
      await restoreBackupRecord(rec);
      restored += 1;
    } catch {
      failed += 1;
    }
  }
  return { restored, failed };
}

export function diffDocuments(oldDoc = {}, currentDoc = {}) {
  const keys = new Set([...Object.keys(oldDoc), ...Object.keys(currentDoc)]);
  const changes = [];
  keys.forEach((k) => {
    const a = JSON.stringify(oldDoc[k]);
    const b = JSON.stringify(currentDoc[k]);
    if (a !== b) changes.push({ field: k, oldValue: oldDoc[k], newValue: currentDoc[k] });
  });
  return changes;
}
